import { useTranslation } from "react-i18next";
import ArrowButton from "./ArrowButton";
import "./DedicatedCloudScreen.scss";
import Lottie from "react-lottie";
import animationData from "./lottie/lottie3/data.json";

function DedicatedCloudScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="fill-absolute">
      <div className="container full-height" style={{ paddingBottom: 50 }}>
        <div className="dedicated-cloud-screen-white-gradient">
          <div className="container">
            <div className="text-container-left">
              <h1 className="blue-header">
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("Innovate.dedicated-cloud-title", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                />
              </h1>
              <p>{t("Innovate.dedicated-cloud-first-paragraph")}</p>
              <p>{t("Innovate.dedicated-cloud-second-paragraph")}</p>
              <a
                href="https://www.avaya.com/en/enterprise-cloud/"
                target="_blank"
                style={{
                  color: "#1b77af",
                  fontWeight: 700,
                  textDecoration: "underline",
                  marginTop: "18px",
                  marginBottom: "14px",
                }}
              >
                {t("Innovate.dedicated-cloud-link")}
              </a>
              <div className={"arrow-buttons-container-left"}>
                <ArrowButton to="/all-cloud" side="left"></ArrowButton>
                <ArrowButton to="/support-services" side="right"></ArrowButton>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="padding flex full-center lottie-container-right"> */}
        <div className="lottie-image-container-right">
          <div className="lottie-animation-container">
            <Lottie
              options={{
                animationData,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DedicatedCloudScreen;
